<template>
  <div>
    <div id="periods" class="field has-addons is-pulled-left">
      <p class="control">
        <button class="button is-small is-hidden-mobile">{{ $t('app.periods') }}</button>
        <button class="button is-small is-hidden-tablet">P</button>
      </p>
      <p v-for="item in periods" v-bind:key="item.id" class="control">
        <button
          v-on:click="setPeriod(item)"
          class="button is-small"
          v-bind:class="{ 'is-link': (item == period) }"
        >{{ item }}</button>
      </p>
    
    <div id="symbols" class="control">      
      <select  class="select" v-model="selected" @change="setSymbol2" style="margin-left:10px">        
        <option v-if= "this.$i18n.locale == 'en'" hidden value="default">Select Symbol</option>      
        <option v-if= "this.$i18n.locale == 'tr'" hidden value="default">Sembol Seçiniz</option>
        <option value="XU100">XU100</option>
        <option value="XUTUM">XUTUM</option>
        <option value="XYUZO">XYUZO</option>
        <option value="X100S">X100S</option>
        <option value="X100C">X100C</option>
        <option value="XK030EA">XK030EA</option>
        <option value="XYLDZ">XYLDZ</option>
        <option value="XKTUM">XKTUM</option>
        <option value="XK100">XK100</option>
        <option value="XK050">XK050</option>
        <option value="XK030">XK030</option>
        <option value="XSRDK">XSRDK</option>
        <option value="XKURY">XKURY</option>
        <option value="XUSRD">XUSRD</option>
        <option value="XSD25">XSD25</option>
        <option value="XUHIZ">XUHIZ</option>
        <option value="XTCRT">XTCRT</option>
        <option value="XSIST">XSIST</option>     
      </select>      
    </div> 
    </div>
    <br/>
    <div id="chart"></div>
  </div>
</template>

<script>
import axios from "axios";
import { createChart } from "lightweight-charts";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["symbol"]),
    ...mapState(["symbol2"])
  },
  data: function() {
    return {    
      periods: [1, 5, 15, 30, 60, "G", "H", "A", "Y"],
      period: "G",
      select:"XU100",
      selected: "default",
      chart: null,
      chart2:null,
      areaSeries: null, 
      areaSeries2: null,    
      series: [],
      series2:[],
      chartSettings: {
        width: 400,
        height: 332,
        priceScale: {
          scaleMargins: {
            top: 0.2,
            bottom: 0.2
          },
          position: "left",
          borderVisible: false
        },
        timeScale: {
          borderVisible: false
        },
        grid: {
          horzLines: {
            color: "#eee"
          },
          vertLines: {
            color: "#ffffff"
          }
        },
        crosshair: {
          horzLine: {
            visible: false,
            labelVisible: false
          },
          vertLine: {
            visible: true,
            style: 0,
            width: 2,
            color: "rgba(32, 38, 46, 0.1)",
            labelVisible: false
          }
        
        }
      }
    };
  },
  
  mounted: function() {
    this.chartSettings.width =
      document.querySelector(".is-two-fifths").clientWidth - 24;
    this.chart = createChart(
      document.querySelector("#chart"),
      this.chartSettings
    );
    this.areaSeries = this.chart.addAreaSeries({
      topColor: "rgba(0, 120, 255, 0.2)",
      bottomColor: "rgba(0, 120, 255, 0.0)",
      lineColor: "rgba(0, 120, 255, 1)",
      lineWidth: 3
    });
     this.areaSeries2 = this.chart.addAreaSeries({
      topColor: "rgba(255, 120, 255, 0.2)",
      bottomColor: "rgba(255, 120, 255, 0.0)",
      lineColor: "rgba(255, 120, 255, 1)",
      lineWidth: 3
    });
    this.fetchData();
   
  },
    
  methods: {       
     fetchData: function() {
      axios
        .get(
          process.env.VUE_APP_PROXY +
          "cmd=CHART2?symbol=" +
            this.symbol +
            "?periyot=" +
            this.period +
            "?bar=220" +
            "?lang=" +
            this.$i18n.locale,
          { responseType: "json" }
        )
        .then(response => this.initJSON(response));
    },
    initJSON: function(response) {
      this.series = [];
      let data = response.data;
    
      data.forEach(item => {
        this.series.push({
          time: Math.round(
            new Date(
              item.Date.replace(/[.]/gi, "-").replace(" ", "T")
            ).getTime() / 1000
          ),
          value: parseFloat(item.Close)
        });
      });
      this.areaSeries.setData(this.series);     
      this.chart.timeScale().fitContent();
      
    },
  
    setPeriod: function(item) {
      this.period = item;
      this.fetchData();
    },

    setSymbol:function(item){    
      this.symbol=item;
      this.fetchData();
    },
    fetchData2: function() {

      axios
        .get(
          process.env.VUE_APP_PROXY +
          "cmd=CHART2?symbol2=" +
            this.selected +
            "?periyot=" +
            this.period +
            "?bar=220" +
            "?lang=" +
            this.$i18n.locale,
          { responseType: "json" }
        )

        .then(response => this.initJSON2(response));
    },
      initJSON2: function(response) {
      console.log(response);
      this.series2 = [];
      let data = response.data;
    
      data.forEach(item => {
        this.series2.push({
          time: Math.round(
            new Date(
              item.Date.replace(/[.]/gi, "-").replace(" ", "T")
            ).getTime() / 1000
          ),
          value: parseFloat(item.Close/100)
        });
      });
      this.areaSeries2.setData(this.series2);     
      this.chart.timeScale().fitContent();
      
    },
      setPeriod2: function(item) {
      this.period = item;
      this.fetchData2();
    },

    setSymbol2:function(item){  
      this.fetchData2(item.target.value);  
    },
  },
};
</script>

<style scoped>
#periods {
  position: relative;
  z-index: 39;
}
#symbols {
  position: relative;
  z-index: 50;
}
</style>